import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GroupedBarChart from '../components/grouped-bar-chart';
import PeriodDropdown from '../components/period-dropdown';
import CategoryDropdown from '../components/category-dropdown';
import { getColorFromKey, getTypeColorFromKey, getSizeColorFromKey } from '../../../../../util/helpers';
import { aggregateAnnualDataForBar } from './chart-helper';

const options = [
  { value: 'outcome', label: 'Outcome' },
  { value: 'type', label: 'Type' },
  { value: 'size', label: 'Size' },
];

const categoriesMap = {
  outcome: ['Won', 'Lost', 'No decision'],
  type: ['New business', 'Renewal', 'Addon', 'Upsell'],
  size: ['Small', 'Medium', 'Large'],
};

const colorsMap = {
  outcome: [getColorFromKey('won'), getColorFromKey('lost'), getColorFromKey('noDecision')],
  type: [getTypeColorFromKey('newBusiness'), getTypeColorFromKey('renewal'), getTypeColorFromKey('addOn'), getTypeColorFromKey('upsell')],
  size: [getSizeColorFromKey('small'), getSizeColorFromKey('medium'), getSizeColorFromKey('large')]
};

const initialPeriod = 12;
const initialSelection = options[0].value;

class OpportunityChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data[initialSelection].map((typeData) => typeData.slice(-initialPeriod)),
      timestamps: props.data.timestamps.slice(-initialPeriod),
      period: 'monthly',
      selection: initialSelection,
    };

    this.handlePeriodChange = this.handlePeriodChange.bind(this);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
  }

  handlePeriodChange(value) {
    const period = value;

    let data = [];
    let timestamps = [];

    switch (period) {
      case 'monthly':
        data = this.props.data[this.state.selection].map((typeData) => typeData.slice(-initialPeriod));
        timestamps = this.props.data.timestamps.slice(-initialPeriod);
        break;
      case 'annual':
        const aggregated = aggregateAnnualDataForBar(this.props.data[this.state.selection], this.props.data.timestamps);
        data = aggregated.data;
        timestamps = aggregated.timestamps;
        break;
      default:
        data = this.props.data[this.state.selection].map((typeData) => typeData.slice(-initialPeriod));
        timestamps = this.props.data.timestamps.slice(-initialPeriod);
        break;
    }

    this.setState({ period: period.toString(), data, timestamps });
  }

  handleSelectionChange(selection) {
    const data = this.props.data[selection].map((typeData) => typeData.slice(-initialPeriod));

    this.setState({ selection, data }, () => {
      this.handlePeriodChange('monthly');
    });
  }

  render() {
    const seriesNames = categoriesMap[this.state.selection];
    const colors = colorsMap[this.state.selection];

    return (
      <div>
        <h5 className="sub-header-with-controls">
          {"View Number of Opportunities By "}
          <CategoryDropdown
            type={this.state.selection}
            handleTypeChange={this.handleSelectionChange}
          />
          {"AND"}
          <PeriodDropdown
            period={this.state.period}
            handlePeriodChange={this.handlePeriodChange}
          />
          {" Periods"}
        </h5>

        <GroupedBarChart
          data={this.state.data}
          xAxisCategories={this.state.timestamps}
          seriesNames={seriesNames}
          colors={colors}
        />
      </div>
    );
  }
}

OpportunityChart.propTypes = {
  data: PropTypes.shape({
    outcome: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
    type: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
    size: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
    timestamps: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
  }).isRequired,
};

export default OpportunityChart;
